import { render, staticRenderFns } from "./TaskMentionChangedActivity.vue?vue&type=template&id=469e33aa"
import script from "./TaskMentionChangedActivity.vue?vue&type=script&lang=js"
export * from "./TaskMentionChangedActivity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports